import React, {useRef, useState} from "react";
import './style/login.css';
import {connect, useDispatch, useSelector} from "react-redux";
import {askPin, createPin, setTentative} from "../redux/pin/pinSlice";
import {Trans, useTranslation} from "react-i18next";
import { logout } from '../api';
import {useRouteNode} from "react-router5";

const max_tentative = 3;

// 3 cases to go on the pin component:
// No pin set: redirected here
// ask for pin: after a certain delay
// from parameters: explicitely changing pin
const Pin = ({ setPinParams,router, current_user}) =>{
    const {user} = current_user;

    const oldPin = useSelector((state) => state.pin.value);
    const tentative = useSelector((state) => state.pin.tentative);
    const ask = useSelector((state) => state.pin.askPin);

    const redirectUrl = useSelector((state) => state.pin.redirectUrl);
    const dispatch = useDispatch();

    const [pin, setPin]=useState(["","","",""]);

    const setEmptyPin = () => setPin(["", "", "", ""]);

    const [tab] = useState([
      useRef(null), useRef(null), useRef(null), useRef(null),
    ])

    const [t] = useTranslation();
    const { route } = useRouteNode('')

    // changePin is in two steps: first check same pin, that reset it
    const changePin = route.name === 'setPin';
    let [etape,setEtape] = useState(0);

    // ensure we are in correct mode (including when going straight to /pin url)
    let state = "change_pin";
    if (ask) { state = "checking_pin" }
    else if (changePin) { state = "change_pin"; }
    else if (oldPin === "") { state = "setting_pin"; }

    // console.log("changePin: ", changePin, " ask: ", ask, "old pin: ", oldPin);
    // console.log("state: ", state);

    let message = "Tapez votre code secret";
    if (state == "change_pin") {
	message = etape === 0 ? 'Entrez votre ancien PIN' : 'Entrez votre nouveau PIN';
    }

    const mail = "support@reticularproject.com";

    function exit() {
        logout().then(() => {
	    dispatch(askPin({value : false, redirectUrl : ""}));
            dispatch(createPin(""));
            dispatch(setTentative(0));

            window.location.href = router.buildPath("login");
        })
    }


    const setNewPinAndRedirect = (pin, url) => {
	    dispatch(askPin({value : false, redirectUrl : ""}));
        dispatch(createPin(pin.join("")));
	    dispatch(setTentative(0));
        sentEvent(mail).then(() => {
            const redirect_url = url ? url : router.buildPath("postfeed");
            setTimeout(() => {
                window.location.href = redirect_url;
            }, 200);
        });
    }
    const sentEvent = async () => {
        const url = "https://analytics.reticular.fr/api/event";
        const headers = {
            'Content-Type': 'application/json',
        }
        const body = {
            "name": "connect",
            "url": window.location.href,
            "domain": window.location.hostname,
            "props":{
                "email": user.email,
            }
        }
         await fetch(url, {
            method: 'POST',
            headers: headers,
            body: JSON.stringify(body)
        });
    }

    const checkChangePin = (pin) => {
      // We are verifying correct pin
      if (etape === 0) {
	if (pin.join('') === oldPin) {
	    dispatch(setTentative(0));
	    setEtape(1);
	} else {
	    dispatch(setTentative(tentative + 1));
	}
	setEmptyPin();
	tab[0].current.focus();
      } else {
	  // Already verified, now we set it
	  setNewPinAndRedirect(pin)
      }
    }

    const checkAskPin = (pin) => {
        if (pin.join('') === oldPin) {
            const redirect_url = !redirectUrl.includes('pin') && redirectUrl;
            setNewPinAndRedirect(pin, redirect_url);
        } else {
            dispatch(setTentative(tentative + 1));
            setEmptyPin();
            tab[0].current.focus();
        }
    }

    const checkAllPin = (pin) => {
        if (pin.filter((item)=>item).length < 4) return;
	
	if (state == "change_pin") { checkChangePin(pin); }
	else if (state == "checking_pin") { checkAskPin(pin); }
	else if (state == "setting_pin") { setNewPinAndRedirect(pin); }
    }

    const handleInputChange = (e, index) => {
	let value = e.nativeEvent.data;
	value = value === null ? "" : value;

	if(isNaN(value)) return;

	const new_pin = pin.slice();
	new_pin[index] = value;

	setPin(new_pin);

	if (index + 1 < pin.length && value !== "") {
	    tab[index+1].current.focus();
	}

	checkAllPin(new_pin);
    }

    if (tentative > max_tentative) {
	exit();
    }

    const pinComponent = (idx) => {
      const value = pin[idx], ref = tab[idx];

      return <div key={idx} className={"pinInputContainer" + (value ? " active": "")}>
	  <input type="password" ref={ref} value={value}
	         pattern="[0-9]" maxLength={1} inputMode="numeric"
		 onChange={(e) => handleInputChange(e, idx)} className="pinInput" />
      </div>
    }

    return (
        <div className={'loginContainer'}>
            <div className={'loginSplitContainer'}>
                <div className={'loginLogo'}>
                </div>
                <div className={'loginLogo loginLogo2'} >
                </div>
            </div>
            <div className={'loginSplitContainer loginFormContainer'}>
                <div className={'loginInputGroupContainer'}>
                    <div className={'loginFormTitle'}>
                        <div className={'pinErrorMessage'}>
                            { tentative > 0 && tentative <= max_tentative && <Trans i18nKey={'tentative'} t={t} count={max_tentative - tentative} >
				{t('Tapez votre code secret')}
			    </Trans>}
                        </div>
                        {t(message)}
                    </div>
                    <div className={'pinGroupContainer'}>{ [0, 1, 2, 3].map(pinComponent) }</div>
                </div>
                <div className={"loginBottomTextContainer"}>
                    <p className={"loginBottomText"}>
                      {t('Mot de passe oublié ? Veuillez contacter Reticular par mail à l\'adresse ')}<br/>
                      <a href={'mailto:' + mail}>{ mail }</a>
                    </p>
                </div>
            </div>

            <div>


            </div>
        </div>)
}

const mapStateToProps = (state) => ({current_user: state.current_user})
export default connect(mapStateToProps, null)(Pin);
